import axios from "axios";
import { TTP_API_URL } from "Config";

axios.defaults.baseURL = TTP_API_URL;
// axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
axios.interceptors.request.use(config => {
  // TODO add token, handle request cancellation ...
  return config;
});

export * from "./auth";
export * from "./media";
export * from "./comment";
export * from "./album";
export * from "./category";
export * from "./filter";
export * from "./user";
export * from "./article";
export * from "./notif";
export * from "./topic";
export * from "./tree";
export * from "./social";



// WEBPACK FOOTER //
// ./src/api/index.js